import ExecutionResult from "~/components/analytics/shared/ResultIcons/ExecutionResult";
import FailureReason from "~/components/analytics/shared/FailureReason";
import { Execution } from "~/components/analytics/shared/type";
import ExecutionDrawerButton from "~/components/analytics/execution/Row/ExecutionDrawerButton";
import MetadataRow, { Separator } from "~/components/analytics/shared/Metadata/MetadataRow";

export type FlakyExecution = Omit<Execution, "duration" | "humanDuration" | "uuid">;

const ExecutionsList = ({ executions }: { executions: Array<FlakyExecution> }) => (
  <div className="px-8 py-5">
    <ul className="flex list-none flex-col flex-wrap gap-2">
      {executions.map((execution) => (
        <li key={execution.id} className="flex max-w-full flex-col gap-2">
          <div className="text-charcoal-700 flex flex-wrap items-center gap-2">
            <ExecutionResult.Small result={execution.result.toUpperCase()} />

            {execution.turboFrameSrc ? (
              <ExecutionDrawerButton
                url={execution.turboFrameSrc}
                classes="color-inherit no-underline hover:underline"
              >
                View execution
              </ExecutionDrawerButton>
            ) : (
              <a className="color-inherit no-underline hover:underline" href={execution.url}>
                View execution
              </a>
            )}

            <Separator />

            <MetadataRow
              createdAt={execution.createdAt}
              buildNumber={execution.buildNumber}
              buildUrl={execution.buildUrl}
              branch={execution.branch}
              linkToBranchTag={true}
            />
          </div>

          {execution.failureReason != null && (
            <div className="pl-6">
              <FailureReason
                failureReason={execution.failureReason}
                endpoint={execution.failureExpandedUrl}
                failureExpanded={execution.failureExpanded}
              />
            </div>
          )}
        </li>
      ))}
    </ul>
  </div>
);

export default ExecutionsList;
